import {Component, Input, OnDestroy, OnInit} from '@angular/core'
import {MatProgressBar} from '@angular/material/progress-bar'
import {MatDialog} from '@angular/material/dialog'
import {MatPaginator, PageEvent} from '@angular/material/paginator'
import {AuthService} from '../../../core/services/auth/auth.service'
import {PagedContactTypeResponse} from '../../../core/models/contact-type.model'
import {EmployeeService} from '../../../core/services/employee/employee/employee.service'
import {ServiceOrderService} from '../../../core/services/service/service-order/service-order.service'
import {
  MatAccordion,
  MatExpansionPanel,
  MatExpansionPanelHeader,
  MatExpansionPanelTitle,
} from '@angular/material/expansion'
import {TableListOSComponent} from '../../../shared/components/table-list-os/table-list-os.component'
import {FormSearchOsNewComponent} from '../../../shared/components/form-search-os-new/form-search-os-new.component'
import {ServiceOrder} from '../../service/service-order/service-order.component'
import {ServiceOrderReplier} from '../../service/service-order-replier/service-order-replier.component'
import {MatButton, MatIconButton} from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import {MatIcon} from '@angular/material/icon'
import {MatTooltip} from '@angular/material/tooltip'
import {ModalFlightStatusConfigComponent} from '../modal-flight-status-config/modal-flight-status-config.component'
import {PassengerService} from '../../../core/services/passenger/passenger.service'
import {
  PassengerCreateLogisticsComponent
} from '../../passengers/passengers-create-logistics/passengers-create-logistics.component'
import {PassagersImportExcelComponent} from '../../passengers/passengers-import-excel/passengers-import-excel.component'
import {
  FormPassengerLogisticsSearchComponent
} from '../../../shared/components/form-passenger-logistics-search/form-passenger-logistics-search.component';
import {MatFormField, MatLabel} from '@angular/material/form-field';
import {MatOption, MatSelect} from '@angular/material/select';
import {downloadBase64File} from '../../../shared/utils/download_base64';
import {
  PassengerEditLogisticsComponent
} from '../../passengers/passengers-edit-logistics/passengers-edit-logistics.component';
import {
  TableListLogisticsPassengerComponent
} from '../../../shared/components/table-list-logistics-passenger/table-list-logistics-passenger.component';
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'
import { ModalImportHistoryComponent } from '../../passengers/modal-import-history/modal-import-history.component'
import { DialogConfirmComponent } from '../../../shared/components/dialog-confirm/dialog-confirm.component'
import { FlightStatusConfigurationService } from '../../../core/services/flight-status/flight-status-configuration.service'

@Component({
  selector: 'logistics-passengers',
  imports: [
    MatProgressBar,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatPaginator,
    MatButton,
    MatIconButton,
    MatIcon,
    MatTooltip,
    FormPassengerLogisticsSearchComponent,
    MatFormField,
    MatSelect,
    MatOption,
    MatLabel,
    MatProgressSpinner,
    TableListLogisticsPassengerComponent,
  ],
  templateUrl: './logistics-passengers.component.html',
  styleUrl: './logistics-passengers.component.scss',
  standalone: true,
  providers: [EmployeeService],
})
export class LogisticsPassengersComponent implements OnInit, OnDestroy {
  constructor(
    private dialog: MatDialog,
    private serviceOrderService: ServiceOrderService,
    private passengerService: PassengerService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private statusVooService: FlightStatusConfigurationService,
  ) {}

  @Input() data: any
  private refreshTimer: any = null
  page = 1
  rows = 10
  numberRows = 0
  itemsList: any[] = []
  loading = false
  searchForm: any = { search: false, model: {} }
  inputSearch = ''
  orderBySelected: string = ''
  selectedPassengers: any[] = []
  deletingBatch = false
  sorts: any[] = [
    { id: 'companhia:asc', description: 'Companhia' },
    { id: 'contato:asc', description: 'Contato' },
    { id: 'cpf:asc', description: 'CPF' },
    { id: 'destinoOrigemAero:asc', description: 'Destino/Origem Aero' },
    { id: 'documento:asc', description: 'Documento' },
    { id: 'nome:asc', description: 'Nome' },
    { id: 'voo:asc', description: 'Voo' },
  ]
  sortChange(event: any) {
    this.orderBySelected = event.value
    this.page = 1
    this.uploadList()
  }
  columns: any[] = [
    {
      keyColumn: 'name',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'document',
      key: 'documento',
      description: 'Documento',
    },
    {
      keyColumn: 'TipoTrecho',
      key: 'tipoTrechoDescricao',
      description: 'Tipo de Trecho',
    },
    {
      keyColumn: 'companhia',
      key: 'companhia',
      description: 'Companhia',
    },
    {
      keyColumn: 'dataHora',
      key: 'dataHora',
      description: 'Data/Hora',
    },
    {
      keyColumn: 'VooNum',
      key: 'voo',
      description: 'Voo',
    },
    {
      keyColumn: 'destinoOrigemAero',
      key: 'destinoOrigemAero',
      description: 'Destino/Origem Voo',
    },
    {
      keyColumn: 'statusVoo',
      key: 'statusVooDescricao',
      description: 'Status Voo',
    },
    {
      keyColumn: 'action',
      key: { edit: false, delete: false, replierItem: false, lookForAlert: true },
      description: 'Ações',
    },
  ]
  screen = 'logistica-passengers'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
    this.startAutoRefresh()
  }

  ngOnDestroy() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  private startAutoRefresh() {
    this.statusVooService.getConfiguracao().subscribe({
      next: (res: any) => {
        const minutes = res.data?.intervaloAtualizacaoMinutos
        if (minutes && minutes > 0) {
          this.refreshTimer = setInterval(() => {
            this.uploadList()
          }, minutes * 60 * 1000)
        }
      },
    })
  }

  checkColumnAction() {
    const index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: true,
        // edit: this.checkPermission('editar'),
        delete: true,
        // delete: this.checkPermission('deletar'),
        replierItem: true,
        lookForAlert: true,
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  getSearchItems(model: any) {
    this.loading = true
    this.passengerService
      .searchPagedPassengerByContract(this.page, this.rows, this.data.id, model, this.orderBySelected)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
          this.loading = false
        },
        error: (err: PagedContactTypeResponse) => {
          this.snackbar.error('Não foi possível listar os passageiros.')
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
  }
  deletePassenger(model: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Excluir passageiro',
        message: 'Deseja excluir esse passageiro? Essa ação não pode ser desfeita.',
        confirmLabel: 'Excluir',
      },
    })

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.loading = true
      this.passengerService.deletePassengerByLogistic(model.id).subscribe({
        next: (_) => {
          this.uploadList()
          this.loading = false
        },
        error: (err: PagedContactTypeResponse) => {
          this.snackbar.error('Não foi possível excluir esse passageiro.')
          this.loading = false
        },
        complete: () => {
          this.loading = false
        },
      })
    })
  }

  createModelSearch(model: any) {
    return {
      nome: model.nome || null,
      documento: model.documento || null,
      contato: model.contato || null,
      cpf: model.cpf || null,

      tipoTrechoId: model.tipoTrechoId || null,

      data: model.data || null,
      vooData: model.vooData || null,

      companhia: model.companhia || null,
      voo: model.voo || null,

      apenasComVoo: model.apenasComVoo ?? null,
      apenasSeVoo: model.apenasSeVoo ?? null,

      origemTipo: model.origemTipo || null,
      origemCidade: model.origemCidade || null,
      origemAeroSigla: model.origemAeroSigla || null,

      destinoTipo: model.destinoTipo || null,
      destinoCidade: model.destinoCidade || null,
      destinoAeroSigla: model.destinoAeroSigla || null,
    }
  }

  search(event: any) {
    this.searchForm = {
      search: event.search,
      model: this.createModelSearch(event.model),
    }
    this.page = 1
    this.uploadList()
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
    // this.search(this.searchResult)
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1
    this.rows = event.pageSize
    this.uploadList()
    // this.search(this.searchResult)
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1
    this.uploadList()
  }

  uploadList() {
    if (this.searchForm.search) {
      this.getSearchItems(this.searchForm.model)
    } else {
      this.getListItems()
    }
    // this.getListItems()
  }

  getInfoPasseger(item: any) {
    switch (item.tipo_trecho_id) {
      case 1: // Transfer In
      case 2: // Transfer Out
      case 3: // PAP In
      case 4: // PAP Out
        return `${item.data} - ${item.hora}`
      case 5: // PAP Aéreo In
      case 6: // PAP Aéreo Out
      case 7: // Outros
        return `${item.companhia} ${item.voo} | ${item.data} - ${item.hora} | ${item.destino_origem_aero}`
      default:
        return '-'
    }
  }

  formatDataHora(data: string, hora: string): string {
    if (!data && !hora) return '-'
    let datePart = data ?? ''
    if (data && data.includes('-') && data.length === 10) {
      const [y, m, d] = data.split('-')
      datePart = `${d}/${m}/${y}`
    }
    if (datePart && hora) return `${datePart} - ${hora}`
    return datePart || hora || '-'
  }

  treatResponse(response: any) {
    const list = []
    if (response.data) {
      for (const item of response.data) {
        list.push({
          ...item,
          info: this.getInfoPasseger(item),
          dataHora: this.formatDataHora(item.data, item.hora),
        })
      }
    }

    this.itemsList = list
    this.numberRows = response.totalItens
  }
  getListItems() {
    this.loading = true
    this.passengerService
      .listPagedPassengerByContract(this.page, this.rows, this.data.id, this.orderBySelected)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {
          this.snackbar.error('Não foi possível listar os passageiros.')
        },
        complete: () => {
          this.loading = false
        },
      })
  }
  getImportModel() {
    this.passengerService.getImportModel().subscribe({
      next: (response: Blob) => {
        const url = window.URL.createObjectURL(response)

        const link = document.createElement('a')
        link.href = url
        link.download = 'modelo-importacao-passageiro.xlsx'
        link.click()

        window.URL.revokeObjectURL(url)
      },
      error: (err) => {
        console.error(err)
      },
    })
  }

  // searchListItems() {
  //   this.loading = true
  //   this.serviceOrderService
  //     .searchPagedServiceOrder(this.page, this.rows, this.searchForm)
  //     .subscribe({
  //       next: (response: any) => {
  //         this.treatResponse(response)
  //       },
  //       error: (err: PagedContactTypeResponse) => { },
  //       complete: () => {
  //         this.loading = false
  //       },
  //     })
  // }

  editItem(item: any) {
    const dialogRef = this.dialog.open(PassengerEditLogisticsComponent, {
      data: { item: item, edit: true, idContrato: this.data.id, alert: item.mensagemCamposFaltantes ?? null },
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
    })

    dialogRef.componentInstance.response.subscribe((response) => {
        this.uploadList()
    })
  }

  deleteItem(item: any) {}
  importPassenger() {
    const dialogRef = this.dialog.open(PassagersImportExcelComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      data: { edit: false, idContrato: this.data.id },
    })

    dialogRef.componentInstance.response.subscribe((response) => {
        this.uploadList()
    })
  }
  openConfigVoo() {
    this.dialog.open(ModalFlightStatusConfigComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '440px',
      maxWidth: '95vw',
    })
  }

  onSelectionChange(selected: any[]) {
    this.selectedPassengers = selected
  }

  deleteBatch() {
    const count = this.selectedPassengers.length
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Excluir passageiros',
        message: `Deseja excluir ${count} passageiro${count > 1 ? 's' : ''} selecionado${count > 1 ? 's' : ''}? Essa ação não pode ser desfeita.`,
        confirmLabel: 'Excluir',
      },
    })

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.deletingBatch = true
      const ids = this.selectedPassengers.map((p) => p.id)
      this.passengerService.deletePassengerBatch(ids).subscribe({
        next: (res: any) => {
          this.snackbar.success(res.message)
          this.selectedPassengers = []
          this.uploadList()
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.deletingBatch = false
        },
      })
    })
  }

  deleteAllPassengers() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
        title: 'Excluir todos os passageiros',
        message: 'Deseja excluir todos os passageiros deste contrato? Essa ação não pode ser desfeita.',
        confirmLabel: 'Excluir',
      },
    })

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return
      this.deletingBatch = true
      this.passengerService.deleteAllPassengersByContract(this.data.id).subscribe({
        next: (res: any) => {
          this.snackbar.success(res.message)
          this.selectedPassengers = []
          this.uploadList()
        },
        error: (err) => {
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.deletingBatch = false
        },
      })
    })
  }

  openImportHistory() {
    this.dialog.open(ModalImportHistoryComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      width: '900px',
      maxWidth: '95vw',
      data: { contratoId: this.data.id },
    })
  }

  addPassenger() {
    const dialogRef = this.dialog.open(PassengerCreateLogisticsComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '100vw',
      width: '100vw',
      maxHeight: '100vh',
      height: '100vh',
      panelClass: 'dialog-fullscreen',
      data: { edit: false, idContrato: this.data.id },
    })

    dialogRef.componentInstance.response.subscribe((response) => {
      this.uploadList()
    })
  }
}


/*
- id
- nome
- documento
- contato
- companhia
- cpf
- tipo_trecho_id
- voo
- hora
- data
- destino_origem_aero
- uf_aero
- logradouro_aero
- numero_aero
- bairro_aero
- cidade_aero
- complemento_aero
- estado_aero
- uf_pap
- logradouro_pap
- numero_pap
- bairro_pap
- cidade_pap
- complemento_pap
*/
